import {
  Paper,
  Box,
} from "@mui/material";

export default function ReportContainer({
  children,
}) {
  return (
    <Paper
      elevation={3}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          p: 3,
        }}
      >
        {children}
      </Box>
    </Paper>
  );
}